import { Drift } from "./drift";
import DRIFT_IDL_JSON from "./drift.json";

export const DRIFT_IDL = DRIFT_IDL_JSON as Drift;
export type DriftIdlType = Drift;
